import { choose } from '../../utils/platform';
import GuestFormDesktop from './GuestForm.desktop';
import GuestFormMobile from './GuestForm.mobile';

// Platform chooser: phone browsers and the APK get the mobile sheet.
export default choose(GuestFormDesktop, GuestFormMobile);
